import { createContext, useContext } from "react";

import type {
  ToggleGroupOrientation,
  ToggleGroupVariant,
} from "./ToggleGroup.types";

export type ToggleGroupContextValue = {
  variant: ToggleGroupVariant;
  orientation: ToggleGroupOrientation;
};

export function makeToggleGroupContext({
  variant = "solid",
  orientation = "horizontal",
}: Partial<ToggleGroupContextValue>): ToggleGroupContextValue {
  return { variant, orientation };
}

export const ToggleGroupContext = createContext<
  ToggleGroupContextValue | undefined
>(undefined);

export function useToggleGroupContext() {
  return useContext(ToggleGroupContext);
}
